import React from "react";

const VerifyLogin = () => {
  return <div>VerifyLogin</div>;
};

export default VerifyLogin;
